__turbopack_context__.v({
  "iconWrap": "dynamic-svg-module-scss-module__qc099a__iconWrap",
});
